import { ImageStore } from './ImageStore';
import { UScopeState } from './UScopeState';
import { ViewportState } from './ViewportState';

export const stores = [
  UScopeState,
  ViewportState,
  ImageStore
];



// WEBPACK FOOTER //
// ./src/shared/stores/uScope/index.js